import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getProductDataCacheKey } from "./constants";
import type { WhatsAppProductData } from "./types";

export const getWhatsAppProductData = reactQueryFetcherAdapter(
  getProductDataCacheKey,
  async (signal, appGroupId: string, messagingServiceId: string): Promise<WhatsAppProductData> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/product_data/${messagingServiceId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
